import { useQuery } from 'react-query'
import { getSettings } from "api"

export const useWordpress = () => useQuery('tmtpcData', getSettings)

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
